import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { getBrowseTutorData, getBrowseTutorDetail } from '../../../Redux/action/StudentAction';
import Beatloader from '../../../Common/BeatLoader';
import ResponsivePagination from '../../../Common/Pagination';

const host = process.env.REACT_APP_API_SERVER
const StudentBrowseTutor = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

   
    const {
        loadingBrowseTutorDataListApi,
        BrowseTutorDataListApiData,
        BrowseTutorDataListApiError,

        loadingBrowseTutorDetailListApi,
        BrowseTutorDetailListApiData,
        BrowseTutorDetailListApiError,
    } = useSelector(state => state?.StudentReducer);

   
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        dispatch(getBrowseTutorData({}))
    }, []);

    
    useEffect(() => {
        if (!BrowseTutorDataListApiData?.data) return;
        
        if (searchTerm.trim() === '') {
            setFilteredData(BrowseTutorDataListApiData.data);
        } else {
            const filtered = BrowseTutorDataListApiData.data.filter(tutor => 
                tutor?.name?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        }
        setCurrentPage(1);
    }, [searchTerm, BrowseTutorDataListApiData]);

    let [initialValues, setInitialValues] = useState({
        search_by: "",
        search_string: "",
        teaching_type: "",
        rating: "",
        experience: "",
    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({}),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            try {
                setSubmitting(true);
                const allEmpty = Object.values(values).every(
                    (val) => val === "" || val === null || val === undefined
                );
                if (allEmpty) {
                    setSubmitting(false);
                    return;
                }
                dispatch(getBrowseTutorData(values))
            }
            catch (error) {
                toast.error(error.response.data.message);
                setSubmitting(false);
            }
        }
    })

    const handleDetailClick = (id) => {
        dispatch(getBrowseTutorDetail(id))
    }

    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const dataPerPage = 10;

   
    useEffect(() => {
        if (!filteredData.length) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(filteredData.slice(start, end));
        setPageCount(Math.ceil(filteredData.length / dataPerPage));
    }, [currentPage, dataPerPage, filteredData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Browse Tutor
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                
                               
                                <div className="row mb-3">
                                    <div className="col-md-5">
                                        <div className="input-group">
                                            <span className="input-group-text bg-primary text-white">
                                                <i className="fas fa-search"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by tutor name..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            {searchTerm && (
                                                <button 
                                                    className="btn btn-outline-secondary" 
                                                    type="button"
                                                    onClick={() => setSearchTerm('')}
                                                >
                                                    ✕
                                                </button>
                                            )}
                                        </div>
                                        <small className="text-muted">
                                            Found {filteredData.length} tutors
                                        </small>
                                    </div>
                                </div>

                                <form onSubmit={formik.handleSubmit} method='post'>
                                    <div className="browse-tutor">
                                        <h5 className="mb-3">Search by</h5>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 mb-2">
                                                <select className="select-form"
                                                    name='search_by'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.search_by} >
                                                    <option value=''>-Select-</option>
                                                    <option>Subject</option>
                                                    <option>Tutor</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-2">
                                                <input
                                                    type="text"
                                                    placeholder="Subject/Tutor"
                                                    className="input-card-form"
                                                    name='search_string'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.search_string}
                                                />
                                            </div>
                                            <h5 className="mb-3">Filter by</h5>
                                            <div className="col-lg-4 col-md-6 mb-2">
                                                <select className="select-form" name='teaching_type'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.teaching_type}>
                                                    <option value=''>-Select Tutoring-</option>
                                                    <option value='0'>One To One Tutoring</option>
                                                    <option value='1'>Group Tutoring</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-2">
                                                <select className="select-form" name='rating'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.rating}>
                                                    <option value=''>-Select Rating-</option>
                                                    <option value='desc'>High To Low</option>
                                                    <option value='asc'>Low To High</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-2">
                                                <select className="select-form" name='experience'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.experience}>
                                                    <option value=''>-Select Experience-</option>
                                                    <option value="0-1">0-1 Year</option>
                                                    <option value="1-2">1-2 Year</option>
                                                    <option value="3">3 above</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <button type='submit' disabled={loadingBrowseTutorDataListApi} className="btn btn-primary w-100">Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                {loadingBrowseTutorDataListApi ?
                                    <Beatloader />
                                    :
                                    <div className="row justify-content-start">
                                        {filteredData.length > 0 ?
                                            currentData?.map((data) => (
                                                <div className="col-lg-6 col-md-6 mt-3" key={data.id}>
                                                    <div className="card input-card-form">
                                                        <div className="card-body">
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-4 col-md-4 col-sm-4 mb-3">
                                                                    <img
                                                                        src={`${host}${data?.profile_img}`}
                                                                        className="img-fluid rounded-circle"
                                                                        style={{ height: "7.6rem", width: "auto" }}
                                                                        onError={(e) => {
                                                                            e.target.src = '/assets/img/user/user.png';
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-lg-8 col-md-8" style={{ width: "fit-content" }}>
                                                                    <h5 className="mb-0">{data?.name}</h5>
                                                                    <p className="mb-0">{data?.tutordetails?.specialization}</p>
                                                                    {data?.tutordetails?.experience && <p className="mb-0">{data?.tutordetails?.experience} Year experience</p>}
                                                                    <div className="rating">
                                                                        {Array.from({ length: 5 }, (_, index) => {
                                                                            if (index < Math.floor(data?.averageRating || 0)) {
                                                                                return <i key={index} className="fas fa-star filled" />;
                                                                            } else if (index < data?.averageRating) {
                                                                                return <i key={index} className="fas fa-star-half-alt filled" />;
                                                                            } else {
                                                                                return <i key={index} className="fas fa-star" />;
                                                                            }
                                                                        })}
                                                                        <span>
                                                                            {data?.averageRating} <span className="text-primary">({data?.total_rating_count} Ratings)</span>
                                                                        </span>
                                                                    </div>
                                                                    <button
                                                                        className="btn btn-primary py-1 w-100 mt-1"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#tutordetailsModal"
                                                                        onClick={() => { handleDetailClick(data?.id) }}
                                                                    >
                                                                        View Profile
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" />
                                                {searchTerm && <p className="mt-2">No tutor found with name "{searchTerm}"</p>}
                                            </div>
                                        }

                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}
                                    </div>}
                            </main>
                        </div>
                    </div>
                </div>
            </section>

            {/* Tutor Details Modal */}
            <div className="modal fade tutor-details-modal" id="tutordetailsModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    {loadingBrowseTutorDetailListApi ?
                        <Beatloader /> :
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Tutor Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <div className="row mb-2">
                                    <div className="col-lg-4">
                                        <img
                                            onError={(e) => { e.target.src = '/assets/img/user/user.png'; }}
                                            src={`${host}${BrowseTutorDetailListApiData?.profile_img}`}
                                            className="img-fluid"
                                            style={{ height: "7.6rem", width: "auto" }}
                                        />
                                    </div>
                                    <div className="col-lg-8 col-md-8" style={{ width: "fit-content" }}>
                                        <h5 className="mb-0">{BrowseTutorDetailListApiData?.name}</h5>
                                        {BrowseTutorDetailListApiData?.tutordetails?.experience && <p className="mb-0">Experience: {BrowseTutorDetailListApiData?.tutordetails?.experience} Years</p>}
                                        <p className="mb-0">Ratings</p>
                                        <div className="rating">
                                            {Array.from({ length: 5 }, (_, index) => {
                                                const averageRating = parseFloat(BrowseTutorDetailListApiData?.avarageRating || "0");
                                                if (index < Math.floor(averageRating)) {
                                                    return <i key={index} className="fas fa-star filled" />;
                                                } else if (index < averageRating) {
                                                    return <i key={index} className="fas fa-star-half-alt filled" />;
                                                } else {
                                                    return <i key={index} className="fas fa-star" />;
                                                }
                                            })}
                                            <span>
                                                {BrowseTutorDetailListApiData?.avarageRating} <span className="text-primary">({BrowseTutorDetailListApiData?.reviewCount} Ratings)</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-lg-12 mb-2">
                                        <p className="mb-0">Subject</p>
                                        <h6>
                                            {[...new Set(BrowseTutorDetailListApiData?.tutorteachingdetails?.map(data => data?.sub_category?.name))]
                                                .filter(Boolean)
                                                .map((name, index, uniqueNames) => (
                                                    <span key={index}>
                                                        {name}
                                                        {index !== uniqueNames.length - 1 && ", "}
                                                    </span>
                                                ))}
                                        </h6>
                                    </div>
                                </div>
                                {BrowseTutorDetailListApiData?.reviews?.length > 0 &&
                                    <div className="row mt-3">
                                        <div className="col-lg-12 mb-2">
                                            <div className="rating">
                                                <h6 className="mb-0">Reviews</h6>
                                                {BrowseTutorDetailListApiData?.reviews?.map((data) => (
                                                    <div key={data.id} className="rating">
                                                        {Array.from({ length: 5 }, (_, index) => {
                                                            const averageRating = parseFloat(data?.rating || "0");
                                                            if (index < Math.floor(averageRating)) {
                                                                return <i key={index} className="fas fa-star filled" />;
                                                            } else if (index < averageRating) {
                                                                return <i key={index} className="fas fa-star-half-alt filled" />;
                                                            } else {
                                                                return <i key={index} className="fas fa-star" />;
                                                            }
                                                        })}
                                                        <p>{data?.review}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>}
                                <div className="row justify-content-center">
                                    <div className="col-lg-12"><p className="mb-0">Tutoring</p></div>
                                    <div className="col-lg-10"><h6>One to One</h6></div>
                                    <div className="col-lg-2"><p>{BrowseTutorDetailListApiData?.tutordetails?.per_session_price_one_to_one}</p></div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12"><p className="mb-0">Group Tutoring</p></div>
                                    <div className="col-lg-10"><h6>Group Class</h6></div>
                                    <div className="col-lg-2"><p>{BrowseTutorDetailListApiData?.tutordetails?.per_session_price_group}</p></div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <Link to={`/student/request-for-one-to-one/${btoa(BrowseTutorDetailListApiData?.id)}`}>
                                    <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">
                                        Request for One to One
                                    </button>
                                </Link>
                                <Link to={`/student/view-group-courses/${btoa(BrowseTutorDetailListApiData?.id)}`}>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                        View Group Courses
                                    </button>
                                </Link>
                            </div>
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default StudentBrowseTutor